import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IComplianceFeedbackPayload } from '../../control/models/photoReport';

const ROOT_URL = '/api/v1/planograms/';

@Injectable({
    providedIn: 'root',
})
export class ImageRecognitionService {
	constructor(private http: HttpClient) {}

	leaveRequest(): Observable<{ status: boolean }> {
		return this.http.post<{ status: boolean }>(`${ROOT_URL}image-recognition/access-request/`, {});
	}

	startComplianceCheck(planogramId: number, photoReportId: number, provider: string = 'openai'): Observable<void> {
		return this.http.post<void>(`${ROOT_URL}${planogramId}/compliance-check/`, {
			photoreport_id: photoReportId,
			provider,
		});
	}

	sendComplianceFeedback(planogramId: number, payload: IComplianceFeedbackPayload): Observable<void> {
		return this.http.post<void>(`${ROOT_URL}${planogramId}/compliance-feedback/`, payload);
	}

	markComplianceSeen(photoreportId: number): Observable<void> {
		return this.http.post<void>(`${ROOT_URL}compliance-seen/`, {
			photoreport_id: photoreportId
		});
	}
}
